import * as React from 'react';
import aos from '@src/utils/aos';
import CmsRichText from '../cms-rich-text';
import styles from './index.less';

const WorldCompetition = ({ content }) => (
  <div className={styles.root}>
    <section className={`${styles.contentSession} ${styles.summarySession}`} aria-label="逐鹿天下比赛信息">
      <div className={styles.content}>
        <div className={styles.summary} data-aos-duration="600" data-aos-once="true" {...aos.FADE_RIGHT()}>
          <CmsRichText className={styles.richText} html={content.competitionDescriptionHtml} />
        </div>
      </div>
    </section>
    <section className={`${styles.contentSession} ${styles.activityRulesSession}`} aria-label="活动规则">
      <div className={styles.content}>
        <h2 className={`${styles.sectionTitle} ${styles.activityTitle}`} data-aos-duration="600" data-aos-once="true" {...aos.FADE_DOWN()}>
          活动规则
        </h2>
        <div className={styles.ruleBox} data-aos-duration="600" data-aos-once="true" {...aos.FADE_UP()}>
          <CmsRichText className={styles.richText} html={content.activityRulesHtml} />
        </div>
      </div>
    </section>
    <section className={`${styles.contentSession} ${styles.gameRulesSession}`} aria-label="赛制规则">
      <div className={styles.content}>
        <h2 className={`${styles.sectionTitle} ${styles.competitionTitle}`} data-aos-duration="600" data-aos-once="true" {...aos.FADE_DOWN()}>
          赛制规则
        </h2>
        <div className={styles.ruleBox} data-aos-duration="600" data-aos-once="true" {...aos.FADE_UP()}>
          <CmsRichText className={styles.richText} html={content.gameRulesHtml} />
        </div>
      </div>
    </section>
  </div>
);

WorldCompetition.defaultProps = {
  content: {}
};

export default WorldCompetition;
